export default "__VITE_ASSET__Bi$Od9Tx__"